<template>
  <v-card v-if="selectedOrder" flat class="container--fluid">
    <v-card flat class="container--fluid bg-gray no-margins zindex-1">
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-row align="center" justify="space-between">
            <v-col cols="12" lg="7" sm="6" class="subtitle-1">
              <!--  <div class="mr-4"><v-icon>$sl-invitation</v-icon></div> -->

              <h4 class="mb-1">BESTÄLLNING AV KORT</h4>
              {{ Lget(selectedOrder, 'company.name', '') }}, {{ Lget(selectedOrder, 'company.postalCity', '') }}
            </v-col>

            <v-col cols="12" lg="5" sm="6" class="text-right d-flex">
              <v-select
                label="STATUS"
                outlined
                :items="basicPrintOrderStates"
                item-text="name"
                item-value="id"
                :rules="[rules.required]"
                v-model="selectedOrder.printOrderStateId"
                :hint="paidDate"
                persistent-hint
                :disabled="!editState"
              ></v-select>
              <v-icon @click="editState = !editState" class="mt-4 ml-3" v-if="!editState" :disabled="!canUpdate">$sl-edit</v-icon>
              <v-icon class="mt-4 ml-3" @click="updateState()" v-else :disabled="!canUpdate">$sl-check</v-icon>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card flat class="container--fluid">
      <v-tabs v-model="tab" class="">
        <v-tabs-slider></v-tabs-slider>

        <v-tab>Fakturaunderlag</v-tab>

        <v-tab>KOMMENTARER</v-tab>

        <v-tab-item>
          <PrintOrderInvoiceDetail @updated="updated"></PrintOrderInvoiceDetail>
        </v-tab-item>

        <v-tab-item>
          <OrderComments :showCreateButton="false" @updated="updated"></OrderComments>
        </v-tab-item>
      </v-tabs>
    </v-card>

    <!-- Set order paid date -->
    <v-dialog v-model="isDialogVisible" max-width="500px" persistent>
      <v-card>
        <v-icon 
          class="close" 
          @click="closeDialog()"
        >
          $sl-close
        </v-icon>

        <v-card-title>
          <span class="display-1">Ange datum för betalning</span>
        </v-card-title>

        <v-card-text>
          <DatePicker
            v-model="paidAt"
            :icon="'$sl-calendar-date'"
            :clearable="true"
            outlined
          />
        </v-card-text>

        <v-card-actions class="d-flex">
          <v-btn class="ml-auto" @click="saveOrderPaidDate()">
            <span class="ml-4">Spara</span>
            <v-icon class="ml-2">$sl-check</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import PrintOrderInvoiceDetail from '@/components/order/printOrder/PrintOrderInvoiceDetail'
import OrderComments from '@/components/order/OrderComments'
import {RulesMixin, CanIDo} from '@/components/mixins'
import find from 'lodash/find'
import Lget from 'lodash/get'
import DatePicker from '@/components/common/DatePicker.vue'
import Sugar from 'sugar'

// @group Order
// OrderDetail component
export default {
  name: 'OrderDetail',

  mixins: [RulesMixin, CanIDo],

  components: {
    PrintOrderInvoiceDetail,
    OrderComments,
    DatePicker
  },

  data: () => ({
    tab: 0,
    editState: false,
    paidAt: null,
    isDialogVisible: false
  }),

  created() {
    this.fetchOrder()
  },

  watch: {
    '$route.params.id': {
      handler: (newVal, OldVal) => {
        this.fetchOrder()
      }
    }
  },

  computed: {
    ...mapGetters('basic', ['basicPrintOrderStates']),
    ...mapGetters('order', ['selectedOrder']),

    isPaidState() {
      return this.selectedOrder.printOrderStateId === 4
    },
    paidDate() {
      const paidAt = this.selectedOrder?.paidAt
      return paidAt ? `Betald den ${Sugar.Date(new Date(this.selectedOrder?.paidAt)).format("{yyyy}-{MM}-{dd}").raw}` : null
    }
  },

  asyncComputed: {
    canUpdate(){
      return this.canIDo('order', 'update');
    },
  },

  methods: {
    ...mapActions('order', ['setSelectedOrder', 'updateSelectedOrder']),

    closeDialog() {
      if ( this.isDialogVisible )
        this.isDialogVisible = false
        
      this.editState = false
      this.fetchOrder()
    },

    saveOrderPaidDate() {
      if ( this.isDialogVisible && !this.paidAt ) {
        return this.$events.fire('showError', 'Du måste välja ett datum.')
      }
       
      this.updateState()
    },

    Lget: Lget,
    /**
     * @vuese
     * Used to update Print order
     * @arg The argument is an integer representing  distance order id and param is state id
     */
    updateState() {
      
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Du måste välja en status.')
        return
      }
      
      if ( this.isPaidState && !this.isDialogVisible ) {
        return this.isDialogVisible = true
      }
      
      this.editState = !this.editState
      
      if (this.$route.params.id > 0) {
        
        let data = { printOrderStateId: this.selectedOrder.printOrderStateId }

        if ( this.isPaidState && this.paidAt ) {
          data = { ...data, paidAt: this.paidAt }
        }

        API.updatePrintOrdersById(this.$route.params.id, { data })
          .then(response => {
            this.$events.fire('showInfo', 'Sparad.')
            /**
             * @vuese
             * Used to update selected order in local store with new state id
             */

            this.updateSelectedOrder({
              stateId: this.selectedOrder.printOrderStateId,
              state: find(this.basicPrintOrderStates, ['id', this.selectedOrder.printOrderStateId])
            })

            //- Close dialog after updating state
            this.closeDialog()
          })
          .catch(error => {
            console.log('There was an error:', error)
            this.$events.fire(
              'showError',
              'Ett fel uppstod (' + error.message + '), om detta händer igen v.v. kontakta BYN:s kansli.'
            )
          })
      }
    },

    updated() {
      this.fetchOrder()
    },
    /**
     * @vuese
     * Used to fetch order
     * @arg The argument is an integer representing  distance order id
     */
    fetchOrder() {
      API.getPrintOrdersById(this.$route.params.id)
        .then(({data = {}}) => {
          let comments = []
          comments.push({
            createdAt: data.createdAt,
            createdBy: data.createdBy,
            content: data.reason,
            regionName: Lget(data, "region.name", '')
          })
          data.comments = comments

          data.type = 'PrintOrder'
          data.orderedAt = data.createdAt

          this.setSelectedOrder(data)
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

<style lang="scss">
</style>